import {apiGetFundTransactions} from "api/reportApi";
import TableSelect from "components/Input/tableSelect";
import Table from "components/Table";
import {useState} from "react";
import TableBalanceComp from "../TableBalanceComp";
import {Header} from "../TablePrintTopComp";

export default function FundTransactions() {
    const [fund, setFund] = useState<any>({});
    const [state, setState] = useState<FinancialPrintCompProps>({});

    return (
        <div className="wrap-journal">
            <Table
                type="fundTransactions"
                middleComp={
                    <TableSelect
                        entity="fund"
                        refetch={apiGetFundTransactions}
                        type="fundTransactions"
                        onChange={(val, financial, dates) => {
                            setFund(financial)
                            setState({financial, dates, balance: `${Intl.NumberFormat().format(financial?.balance || 0)} ${financial?.Currency?.fa_title || ""}`})
                        }}
                    />
                }
                titleSection={
                    <TableBalanceComp title="مانده حساب" currency={fund?.Currency?.fa_title} balance={fund?.balance}/>
                }
                printComp={FinancialPrintComp(state)}
                sumAmountInfo={[
                    {name:"creditor",isCurrency:true},
                    {name:"debtor",isCurrency:true},
                    ]}
            />
        </div>
    );
}

interface FinancialPrintCompProps {
    financial?: any;
    dates?: any;
    balance?: any;
}

function FinancialPrintComp(props: { financial?: any; dates?: any; balance?: any }) {
    const financial = props.financial || {};
    const toDate = props.dates?.toDate;
    const fromDate = props.dates?.fromDate;
    const RD = toDate && fromDate ? `گزارش ازتاریخ :${fromDate} تا تاریخ :${toDate}` : "گزارش برای کل سال مالی";
    const name = financial.name ? `گردش حساب ${financial.name}` : "";
  const remaining = props.balance || ""
  const totalRemaining = `مانده حساب : ${remaining}`
    return (
        <div>
            <Header texts={[RD, name, totalRemaining]}/>
        </div>
    );
}